export const SMALL_CAROUSEL_BREAKPOINTS = {
    0: {
        slidesPerView: 1.2,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 16,
    },
    768: {
        slidesPerView: 1.9,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
    },
};

export const STANDARD_CAROUSEL_BREAKPOINTS = {
    0: {
        slidesPerView: 1.2,
        spaceBetween: 16,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
    },
    768: {
        slidesPerView: 2.3,
        spaceBetween: 16,
        slidesOffsetBefore: 40,
        slidesOffsetAfter: 40,
    },
    1024: {
        slidesPerView: 2.7,
        spaceBetween: 16,
        slidesOffsetBefore: 40,
        slidesOffsetAfter: 40,
    },
    1152: {
        slidesPerView: 3.2,
        spaceBetween: 16,
        slidesOffsetBefore: 40,
        slidesOffsetAfter: 40,
    },
    1280: {
        slidesPerView: 3.5,
        spaceBetween: 24,
    },
    1440: {
        slidesPerView: 4,
        spaceBetween: 24,
    },
};
